import { Component, OnInit } from '@angular/core';
import { Constant, FIELD_COMPONENT, MODULE_NAME, RoleIdEnum } from 'app/config/constants';
import { CommonService } from 'app/service/common.service';
import { DataService } from 'app/service/data.service';
import { MenuActionService } from 'app/service/menu-action.service';

@Component({
  selector: 'menu-ticket-manager',
  templateUrl: './menu-ticket-manager.component.html',
  styleUrls: ['./menu-ticket-manager.component.scss']
})
export class MenuTicketManagerComponent implements OnInit {
  FIELD_COMPONENT = FIELD_COMPONENT;
  MODULE_NAME = MODULE_NAME;
  isTabSalesRecord: boolean = true; // Check chose tab combination
  isTabReservation: boolean;
  isTabReport: boolean;
  isTabReservationManager: boolean;
  isDisplayDeleteReservation: boolean;
  isTabSaleResult: boolean;
  isRoot: boolean;
  isAdmin: boolean;
  isDisplayEditReservation: boolean;

  constructor(private dataService: DataService, private menuActionService: MenuActionService, private commonService: CommonService) {
    this.dataService.currentData.subscribe(data => {
      switch (data[0]) {
        case Constant.IS_TAB_SALES_RECORD: {
          this.isTabSalesRecord = <boolean>data[1];
          break;
        }
        case Constant.IS_TAB_SALE_RESULT: {
          this.isTabSaleResult = <boolean>data[1];
          break;
        }
        case Constant.IS_TAB_RESERVATION: {
          this.isTabReservation = <boolean>data[1];
          break;
        }
        case Constant.IS_TAB_REPORT: {
          this.isTabReport = <boolean>data[1];
          break;
        }
        case Constant.IS_TAB_RESERVATION_MANAGER: {
          this.isTabReservationManager = <boolean>data[1];
          break;
        }
        case Constant.IS_DISPLAY_DELETE_RESERVATION: {
          this.isDisplayDeleteReservation = <boolean>data[1];
          break;
        }
        case Constant.IS_DISPLAY_EDIT_RESERVATION: {
          this.isDisplayEditReservation = <boolean>data[1];
          break;
        }
      }
    });
    this.isRoot = this.commonService.getCommonObject().infoUser['custom:superuser'];
  }

  ngOnInit(): void {}

  /**
   * execute action for export list ticket in menu
   * @param {string} moduleName current module name
   */
  exportListTicket(moduleName: string): void {
    this.menuActionService.exportTickets(moduleName);
  }

  /**
   * execute action for refund web in menu
   * @param {string} moduleName current module name
   */
  refundTickets(moduleName: string): void {
    this.menuActionService.refundTickets(moduleName);
  }

  /**
   * execute action for clear setting in menu Edit
   * @param {string} moduleName current module name
   */
  clearSetting(moduleName: string) {
    this.menuActionService.clearSetting(moduleName);
  }

  // /**
  //  * sortAndFilter
  //  * @param moduleName
  //  */
  // sortAndFilter(moduleName: string) {
  //   this.menuActionService.sortAndFilter(moduleName);
  // }

  /**
   * addReservation
   * @param moduleName
   */
  addReservation(moduleName: string) {
    this.menuActionService.addReservation(moduleName);
  }

  /**
   * editReservation
   * @param moduleName
   */
  editReservation(moduleName: string) {
    this.menuActionService.editReservation(moduleName);
  }

  /**
   * duplicateReservation
   * @param moduleName
   */
  duplicateReservation(moduleName: string) {
    this.menuActionService.duplicateSetting(moduleName);
  }

  /**
   * deleteReservation
   * @param moduleName
   */
  deleteReservation(moduleName: string) {
    this.menuActionService.deleteReservation(moduleName);
  }

  /**
   * reissueReceipt
   * @param moduleName
   */
  reissueReceipt(moduleName: string): void {
    this.menuActionService.reissueReceipt(moduleName);
  }

  /**
   * refundSetting
   * @param moduleName
   */
  refundSetting(moduleName: string): void {
    this.menuActionService.refundSetting(moduleName);
  }

  /**
   * refundCancel
   * @param moduleName
   */
  refundCancel(moduleName: string): void {
    this.menuActionService.refundCancel(moduleName);
  }

  /**
   * execute action for refund web in menu
   * @param {string} moduleName current module name
   */
  bulkRefundTickets(moduleName: string): void {
    this.menuActionService.bulkRefundTickets(moduleName);
  }

  /**
   * setTicketQuantityDisplay
   * @param moduleName
   */
  setTicketQuantityDisplay(moduleName: string): void {
    this.menuActionService.setTicketQuantityDisplay(moduleName);
  }
}
